import { soft } from './softStyles';

// Marks the signed-in player's row in the standings and picks tables.
const style = {
  marginLeft: '8px',
  padding: '2px 8px',
  borderRadius: '999px',
  fontSize: '11px',
  fontWeight: 500,
  backgroundColor: '#DBEAFB',
  color: '#0B4F8F',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
};

const YouChip = () => <span style={style}>You</span>;

export default YouChip;
